import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const Policy = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <h1>{t('Privacy policy')}</h1>
      <ol>
        <li>{t('Policy_1')}</li>
        <li>{t('Policy_2')}</li>
        <li>{t('Policy_3')}</li>
        <li>{t('Policy_4')}</li>
        <li>{t('Policy_5')}</li>
        <li>{t('Policy_6')}</li>
        <li>{t('Policy_7')}</li>
        <li>{t('Policy_8')}</li>
        <li>{t('Policy_9')}</li>
      </ol>
    </div>
  );
};

export default Policy;
